import { Base64 } from 'js-base64';
import { SOURCES } from '../../../../constants/sources';
import { DEFAULT as DEFAULT_START_PAGE } from '../../../../constants/start-page';
import { APPLICATION_MODE } from '../../../../constants/layout';

const getFromCode = (code) => {
    switch (code) {
        case 'code':
            return 'test-code';
        case 'qr':
            return 'qr-code';
        default:
            return 'direct-link';
    }
};

export const generatePayloadForOpenAssignment = (assignment, user, from) => {
    const payload = {
        assignmentId: assignment.id,
        bookId: assignment.bookInfo ? assignment.bookInfo.bookId : -1,
        originalId: assignment.homeworkId,
        source: SOURCES.LAZE,
        profile: assignment.profile,
        isPreview: false,
        saveStatus: true,
        isTerminationTracked: false,
        lazeUser: user,
        openedFrom: getFromCode(from),
        mode: assignment.mode ?? APPLICATION_MODE.DEFAULT,
        firstPage: assignment.firstPage ?? DEFAULT_START_PAGE,
        backToHome: true,
    };

    return Base64.encode(JSON.stringify(payload));
};

export const generatePayloadForLazeAssignment = (assignment, from, isTeacher = false) => {
    const payload = {
        assignmentId: assignment.id,
        bookId: assignment.bookInfo ? assignment.bookInfo.bookId : -1,
        originalId: assignment.homeworkId,
        source: SOURCES.LAZE,
        profile: assignment.profile,
        isPreview: false,
        saveStatus: !isTeacher,
        isTerminationTracked: false,
        openedFrom: getFromCode(from),
        mode: assignment.mode ?? APPLICATION_MODE.DEFAULT,
        firstPage: assignment.firstPage ?? DEFAULT_START_PAGE,
        uniqueCode: assignment.uniqueCode,
        className: assignment.className,
        backToHome: true,
    };

    return Base64.encode(JSON.stringify(payload));
};
